import type { LoginValidationErrors } from '@shared/api'
import type { AxiosError } from 'axios'

import { resolvePostLoginPath, useAuthStore } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useAuthApi } from '../api/auth.hook'

interface UseSectionLoginReturn {
  forgotUrl: string
  onInputEmail: (value: string | number) => void
  onInputPassword: (value: string | number) => void
  onClickRemember: () => void
  setSubmitLogin: () => void
}

export const useSectionLogin = (): UseSectionLoginReturn => {
  const toast = useToast()
  const route = useRoute()
  const authStore = useAuthStore()
  const { login } = useAuthApi()

  const forgotUrl = useAdminRoutes('admin.password') || ''

  const onInputEmail = (value: string | number): void => {
    authStore.setEmail(value.toString())
    authStore.setEmailError(null)
  }

  const onInputPassword = (value: string | number): void => {
    authStore.setPassword(value.toString())
    authStore.setPasswordError(null)
  }

  const onClickRemember = (): void => {
    authStore.setRemember(!authStore.isRemember)
  }

  const validate = (): boolean => {
    let valid = true
    if (!authStore.email || authStore.email.length === 0) {
      authStore.setEmailError('Please fill in this field.')
      valid = false
    }
    if (!authStore.password || authStore.password.length === 0) {
      authStore.setPasswordError('Please fill in this field.')
      valid = false 
    }
    
    return valid
  }

  const setSubmitLogin = (): void => {
    const isValid = validate()
    if (isValid) {
      login({
        email: authStore.getEmail,
        password: authStore.getPassword,
      }, {
        onSuccess: (data) => {
          authStore._applyTokens(data.data)
          navigateTo(resolvePostLoginPath(route.query))
        },
        onError: (error: AxiosError<LoginValidationErrors>) => {
          toast.error(error.response?.data?.message || 'Unexpected error')
        },
      })
    }
  }

  return {
    forgotUrl,
    onInputEmail,
    onInputPassword,
    onClickRemember,
    setSubmitLogin,
  }
}
